module.exports = __webpack_public_path__ + "static/media/Suspension-red.50e3d76b.svg";